import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { CardLabel, FormStep, Loader, RadioOrSelect, TextInput, Toast, UploadFile } from "@egovernments/digit-ui-react-components";

const EDCRForm = ({ t, config, onSelect, formData, isShowToast, isSubmitBtnDisable, setIsShowToast }) => {
  const code = 'up';
  const applicationFlow = Digit?.SessionStorage?.get("CITIZEN.COMMON.HOME.FLOW")?.toLowerCase();
  const tcpCode = applicationFlow === 'tcp';
  const udCode = applicationFlow === 'ud';

  const { data: cityList, isLoading: isCityListLoading } = Digit?.Hooks.useTenants();
  const citymoduleList = !isCityListLoading && cityList.filter((e) => e?.code?.includes('avp'))?.[0]?.boundary || []
  const scrutinyDetails = Digit?.SessionStorage.get(config.key);

  const [selectedCity, setSelectedCity] = useState(scrutinyDetails?.city || null);
  const [localities, setLocalities] = useState(selectedCity?.boundary || null);
  const [selectedLocality, setSelectedLocality] = useState(scrutinyDetails?.locality || null);
    const [areaType, setAreaType] = useState('');
    const selectedLocalityIndex = localities?.findIndex((e) => e.name === selectedLocality?.name);
    const [villages, setVillages] = useState(selectedLocality?.children || localities?.[selectedLocalityIndex]?.children || []);
  const [village, setVillage] = useState(scrutinyDetails?.village || null);
    const [villageOpen, setOpenVillage] = useState(!!selectedLocality || false);
  const [name, setName] = useState(scrutinyDetails?.applicantName || formData?.Scrutiny?.[0]?.applicantName);
    const [uploadedFile, setUploadedFile] = useState(() => formData?.Scrutiny?.[0]?.proofIdentity?.fileStoreId || null);
    const [file, setFile] = useState(formData?.owners?.documents?.proofIdentity);
    const [uploadMessage, setUploadMessage] = useState("");

    const history = useHistory();

    let validation = { };

    function setApplicantName(e) {
        setName(e.target.value);
    }

    function selectfile(e) {
        setUploadedFile(e.target.files[0]);
        setFile(e.target.files[0]);
    }

    const onSkip = () => {
        setUploadMessage("NEED TO DELETE");
    };

    function selectCity(city) {
        setSelectedCity(city);
        setLocalities(city?.children);
        setOpenVillage(true);
        setSelectedLocality(null);
        setVillage(null);
        setAreaType(city?.Unit)
        sessionStorage.setItem("currentCity", JSON.stringify(city));
        Digit?.SessionStorage.set("CITIZEN.COMMON.HOME.DIST", city);
        formData.landAreaDetails = { city };
      }

      function selectLocality(locality) {
        if (formData?.landAreaDetails?.locality) {
          formData.landAreaDetails["locality"] = locality;
        }
       // const boundaryIndex = localities?.findIndex((e) => e.name === locality.name)
        setSelectedLocality(locality);
        //setVillages(localities?.[boundaryIndex]?.children)
       // setOpenVillage(true)
        //setAreaType(localities?.[boundaryIndex]?.IsSpecialArea ? `Special Area` : `Planning Area`)
        sessionStorage.setItem("currLocality", JSON.stringify(locality));
      }
    
      function selectVillage(village) {
        if (formData?.landAreaDetails?.village) {
          formData.landAreaDetails["village"] = village;
        }
        setVillage(village)
        sessionStorage.setItem("currVillage", JSON.stringify(village));
      }

    useEffect(() => {
        if (uploadMessage || isShowToast) {
            setName("");
            setUploadedFile(null);
            setFile("");
            setUploadMessage("");
        }
        if (isShowToast) {
            history.replace(
                `/digit-ui/citizen/obps/edcrscrutiny/apply/acknowledgement`,
                { data: isShowToast?.label ? isShowToast?.label : "BPA_INTERNAL_SERVER_ERROR", type: "ERROR"}
              );
        }
    }, [uploadMessage, isShowToast, isSubmitBtnDisable]);

    function onAdd() {
        setUploadMessage("NEED TO DELETE");
    }

    const handleSubmit = () => {
        const data = { };
        data.tenantId = code;
        data.city = selectedCity;
        data.areaType = areaType || null

      data.locality = selectedLocality || null;
      data.village = village || null;
      data.applicantName = name;
      data.file = file || uploadedFile || null;
      Digit?.SessionStorage.set(config.key, data);

      data.locality = selectedLocality?.name || "";
        data.village = village?.name || "";
        data.doorNo = selectedLocality?.name || null
        onSelect(config.key, data);
    };

    if (isCityListLoading || isSubmitBtnDisable) {
        return <Loader />;
    }
    
    return (
        <FormStep
            t={t}
            config={config}
            onSelect={handleSubmit}
            onSkip={onSkip}
            isDisabled={!selectedCity || !name || !file || isSubmitBtnDisable}
            onAdd={onAdd}
            isMultipleAllow={true}
        >
            {/* <CardLabel>{`${t("BPA_DISTRICT_LABEL")} *`}</CardLabel> */}
            <CardLabel>{`${t("City")} *`}</CardLabel>
            <RadioOrSelect
            t={t}
            optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
            options={citymoduleList}
            selectedOption={selectedCity}
            onSelect={selectCity}
            optionKey="name"
            placeholder={`Select ${t("City")}`}
            />
            {(selectedCity && localities?.length > 0) && (
            <span className={"form-pt-dropdown-only"}>
            {/* <CardLabel>{`${t("BPA_LOC_NOTIFIED-AREA_LABEL")}*`}</CardLabel> */}
            <CardLabel>{`${t("Schemes")}*`}</CardLabel>
            <RadioOrSelect
                optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
                isMandatory={false}
                options={localities?.sort((a, b) => a.name.localeCompare(b.name))}
                optionKey="name"
                selectedOption={selectedLocality}
                onSelect={selectLocality}
                t={t}
                isDependent={true}
                isDropDown={true}
            />
            </span>
         )}
         {(selectedCity && udCode && localities?.length > 0) && (
        <span className={"form-pt-dropdown-only"}>
          {/* <CardLabel>{`${t("BPA_ULB-AREA_LABEL")}*`}</CardLabel> */}
          <CardLabel>{`${t("Scheme")}*`}</CardLabel>
          <RadioOrSelect
            optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
            isMandatory={false}
            options={localities?.sort((a, b) => a.name.localeCompare(b.name))}
            optionKey="name"
            selectedOption={selectedLocality}
            onSelect={selectLocality}
            t={t}
            isDependent={true}
          />
        </span>
      )}

    {(selectedCity && selectedLocality &&  villageOpen && localities?.length > 0) && (
        <div>
          {/* <CardLabel>{`${t("BPA_AREA_TYPE_LABEL")}`}</CardLabel> */}
          <CardLabel>{`${t("Unit")}`}</CardLabel>
          <TextInput
            t={t}
            type={"text"}
            optionKey="i18nKey"
            name="areaType"
            value={areaType}
            disabled={true} />
        </div>
      )}

    {/* {(selectedCity && villageOpen && tcpCode && villages?.length > 0) && (
        <span className={"form-pt-dropdown-only"}>
          <CardLabel>{`${t("BPA_LOC_VILLAGE-AREA_LABEL")}`}</CardLabel>
          <RadioOrSelect
            optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
            isMandatory={false}
            options={villages?.sort((a, b) => a.name.localeCompare(b.name))}
            optionKey="name"
            selectedOption={village}
            onSelect={selectVillage}
            t={t}
            isDependent={true}
            isDropDown={true}
          />
        </span>
      )} */}

    {/* {(selectedCity && villageOpen && udCode && villages?.length > 0) && (
        <span className={"form-pt-dropdown-only"}>
          <CardLabel>{`${t("BPA_LOC_WARD-AREA_LABEL")}`}</CardLabel>
          <RadioOrSelect
            optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
            isMandatory={false}
            options={villages?.sort((a, b) => a.name.localeCompare(b.name))}
            optionKey="name"
            selectedOption={village}
            onSelect={selectVillage}
            t={t}
            isDependent={true}
            isDropDown={true}
          />
        </span>
      )} */}
            {/* <CardLabel>{`${t("EDCR_SCRUTINY_NAME_LABEL")} *`}</CardLabel> */}
            <CardLabel>{`${t("Owner Name")} *`}</CardLabel>

            <TextInput
                isMandatory={false}
                optionKey="i18nKey"
                t={t}
                name="applicantName"
                onChange={setApplicantName}
                uploadMessage={uploadMessage}
                value={name}
                {...(validation = {
                    isRequired: true,
                    pattern: "^[a-zA-Z]+(( )+[a-zA-z]+)*$",
                    type: "text",
                    title: t("TL_NAME_ERROR_MESSAGE"),
                })}
            />
            <CardLabel>{`${t("BPA_PLAN_DIAGRAM_LABEL")} *`}</CardLabel>
            <UploadFile
                id={"edcr-doc"}
                extraStyleName={"propertyCreate"}
                accept=".dxf"
                onUpload={selectfile}
                onDelete={() => {
                    setUploadedFile(null);
                    setFile("");
                }}
                message={uploadedFile ? `1 ${t(`PT_ACTION_FILEUPLOADED`)}` : t(`ES_NO_FILE_SELECTED_LABEL`)}
                uploadMessage={uploadMessage}
            />
            <div style={{ disabled: "true", height: "30px", width: "100%", fontSize: "14px" }}>{t("EDCR_UPLOAD_FILE_LIMITS_LABEL")}</div>
            {isShowToast && <Toast error={isShowToast.key} label={t(isShowToast.label)} onClose={() => setIsShowToast(null)} isDleteBtn={true} />}
            {/* {isSubmitBtnDisable ? <Loader /> : null} */}
        </FormStep>
    );
};

export default EDCRForm;
